module.exports = __webpack_public_path__ + "static/media/p4pLogo.398c2887.png";